import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.324 19.093c-.412 0-.765-.146-1.06-.44a1.444 1.444 0 0 1-.44-1.06c0-.412.147-.765.44-1.059.295-.294.648-.44 1.06-.44.413 0 .766.146 1.06.44.293.294.44.647.44 1.06 0 .412-.147.765-.44 1.059-.294.294-.647.44-1.06.44m0-5.769a1.45 1.45 0 0 1-1.06-.44 1.444 1.444 0 0 1-.44-1.06c0-.412.147-.765.44-1.06a1.45 1.45 0 0 1 1.06-.44c.413 0 .766.147 1.06.44.293.295.44.648.44 1.06 0 .413-.147.766-.44 1.06-.294.293-.647.44-1.06.44m0-5.769a1.45 1.45 0 0 1-1.06-.44 1.444 1.444 0 0 1-.44-1.06c0-.412.147-.766.44-1.06a1.45 1.45 0 0 1 1.06-.44c.413 0 .766.147 1.06.44.293.294.44.648.44 1.06 0 .413-.147.766-.44 1.06-.294.293-.647.44-1.06.44" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }